import type { ReportState, ReportingPeriod, UpdateLink, WeeklyUpdateSection } from '@mfos/shared';
import type { BadgeTone } from '../../components/Badge';
import { formatDate } from '../../lib/format';

export const REPORT_STATE_DISPLAY: Readonly<
  Record<ReportState, { label: string; tone: BadgeTone }>
> = {
  NOT_STARTED: { label: 'Not started', tone: 'neutral' },
  DRAFT: { label: 'Draft (not submitted)', tone: 'info' },
  SUBMITTED: { label: 'Submitted on time', tone: 'ok' },
  LATE: { label: 'Submitted late', tone: 'warn' },
  OVERDUE: { label: 'Overdue — still accepted', tone: 'down' },
  MISSING: { label: 'Missing', tone: 'down' },
  EXCUSED: { label: 'Excused', tone: 'neutral' },
  NOT_EXPECTED: { label: 'Not expected', tone: 'neutral' },
};

/** Short labels for dense tables; the tone and icon still carry the same meaning. */
export const REPORT_STATE_SHORT: Readonly<Record<ReportState, string>> = {
  NOT_STARTED: 'Not started',
  DRAFT: 'Draft',
  SUBMITTED: 'On time',
  LATE: 'Late',
  OVERDUE: 'Overdue',
  MISSING: 'Missing',
  EXCUSED: 'Excused',
  NOT_EXPECTED: 'Not expected',
};

const PERIOD_NAMES = { WEEKLY: 'Week', BIWEEKLY: 'Two weeks', MONTHLY: 'Month' } as const;

/** "Week 5 Oct 2026 – 11 Oct 2026". */
export function periodLabel(period: Pick<ReportingPeriod, 'periodType' | 'startsOn' | 'endsOn'>) {
  return `${PERIOD_NAMES[period.periodType]} ${formatDate(period.startsOn)} – ${formatDate(period.endsOn)}`;
}

export function linksBySection(
  links: readonly UpdateLink[],
): ReadonlyMap<WeeklyUpdateSection, UpdateLink[]> {
  const grouped = new Map<WeeklyUpdateSection, UpdateLink[]>();
  for (const link of links) {
    const list = grouped.get(link.section) ?? [];
    list.push(link);
    grouped.set(link.section, list);
  }
  return grouped;
}
